import React from "react";
import ErrorNotification from "../ErrorNotification/ErrorNotification";
import Routing from "../Routing/Routing";
import { ToastContainer } from "react-toastify";
import InstallPwa from "../InstallPwa/InstallPwa";

export const Main = () => {
  return (
    <div style={{ marginTop: "85px", paddingBottom: 80 }}>
      <ErrorNotification />
      <Routing />
      <ToastContainer autoClose={3000} hideProgressBar />
      <InstallPwa />
    </div>
  );
};
